function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useField, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { FormGroup } from 'reactstrap';
import { Error, Label } from "./..";
import helper from "./helper";
export default (function (_ref) {
  var name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      onSelect = _ref.onSelect,
      options = _ref.options,
      _ref$clearable = _ref.clearable,
      clearable = _ref$clearable === void 0 ? false : _ref$clearable,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      _ref$groupTag = _ref.groupTag,
      groupTag = _ref$groupTag === void 0 ? FormGroup : _ref$groupTag,
      _ref$labelTag = _ref.labelTag,
      labelTag = _ref$labelTag === void 0 ? Label : _ref$labelTag,
      _ref$errorTag = _ref.errorTag,
      errorTag = _ref$errorTag === void 0 ? Error : _ref$errorTag,
      _ref$inputTag = _ref.inputTag,
      inputTag = _ref$inputTag === void 0 ? Select : _ref$inputTag,
      _ref$groupProps = _ref.groupProps,
      groupProps = _ref$groupProps === void 0 ? {} : _ref$groupProps,
      _ref$labelProps = _ref.labelProps,
      labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      _ref$errorProps = _ref.errorProps,
      errorProps = _ref$errorProps === void 0 ? {} : _ref$errorProps,
      props = _objectWithoutProperties(_ref, ["name", "label", "value", "onSelect", "options", "clearable", "multiple", "size", "groupTag", "labelTag", "errorTag", "inputTag", "groupProps", "labelProps", "inputProps", "errorProps"]);

  var _useField = useField({
    name: name
  }),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      fieldHelper = _useField2[2];

  var _useFormikContext = useFormikContext(),
      submitCount = _useFormikContext.submitCount,
      mapping = _useFormikContext.mapping,
      resource = _useFormikContext.resource;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      inputOptions = _useState2[0],
      setInputOptions = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var GroupTag = groupTag;
  var LabelTag = labelTag;
  var ErrorTag = errorTag;
  var InputTag = inputTag;
  var invalid = (meta.touched || submitCount > 0) && meta.error !== undefined;
  label = labelProps.text || label;

  if (label === undefined) {
    label = name;
  }

  useEffect(function () {
    if (options !== undefined) {
      setInputOptions(options);
    } else if (mapping) {
      // If not choices, please verify on the server side the validation groups
      setInputOptions(mapping.getChoices(name));
    } else if (resource) {
      setLoading(true);
      resource.fetchOptions(name).then(function (resourceOptions) {
        setInputOptions(resourceOptions);
        setLoading(false);
      });
    }
  }, [options, mapping, resource, name]);
  return /*#__PURE__*/React.createElement(GroupTag, groupProps, label && /*#__PURE__*/React.createElement(LabelTag, _extends({
    name: name,
    size: size
  }, labelProps), label), /*#__PURE__*/React.createElement(InputTag, _extends({
    name: name,
    placeholder: "",
    isMulti: multiple,
    invalid: invalid,
    options: inputOptions,
    isLoading: loading,
    isDisabled: loading,
    isClearable: clearable,
    onChange: function onChange(option) {
      var realValue = helper.fromChoicesToValues(option, inputOptions, multiple);

      if (onSelect) {
        onSelect(realValue);
      } else {
        fieldHelper.setValue(realValue);
      }
    },
    onBlur: function onBlur() {
      return fieldHelper.setTouched(true);
    },
    styles: helper.buildStyles(size, invalid),
    value: value || helper.fromValuesToChoices(field.value, inputOptions, multiple)
  }, props, inputProps)), /*#__PURE__*/React.createElement(ErrorTag, _extends({
    name: name
  }, errorProps)));
});